import { DataPoint } from '../../../../../components/charts/recharts.models';
import { EntityScores } from '../../../../../models/overmind/analytics';
import { Score } from '../../../../../models/view/score';

function formatScore(score?: Score, useLevels?: boolean): number | string {
  return score ? (useLevels ? score.level : score.percentage) : 'Not assessed';
}

export function generateUniqueSkillNames(scores: EntityScores[] | undefined): string[] {
  if (!scores?.length) return [];

  const uniqueSkillNames = new Set<string>();

  scores.forEach(score => {
    score.scores.forEach(score => {
      uniqueSkillNames.add(score.name);
    });
  });

  return Array.from(uniqueSkillNames);
}

export function transformScores(scores: EntityScores[] | undefined, uniqueSkillNames: string[], useLevels: boolean): DataPoint[] {
  if (!scores?.length) return [];

  return scores.map(score => {
    const dataPoint: DataPoint = { name: score.name, slug: score.slug };

    uniqueSkillNames.forEach(skillName => {
      dataPoint[skillName] = 'Not assessed';
    });

    score.scores.forEach(score => {
      dataPoint[score.name] = formatScore(score.score, useLevels);
    });

    return dataPoint;
  });
}

export function transformAverageScores(scores: EntityScores[], useLevels: boolean): DataPoint[] {
  return scores.map(score => {
    const dataPoint: DataPoint = { name: 'Average', slug: score.slug };
    score.scores.forEach(score => {
      dataPoint[score.name] = formatScore(score.score, useLevels);
    });
    return dataPoint;
  });
}

